export function formatBytes(bytes: number): string {
  if (!bytes || bytes < 0) {
    return "0 Б";
  }
  if (bytes < 1024) {
    return `${bytes} Б`;
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} КБ`;
  }
  return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
}

export function formatNumber(value: number): string {
  return value.toLocaleString("ru-RU");
}

export function formatCredits(amount: number): string {
  return `${amount.toLocaleString("ru-RU")} кр.`;
}

export function formatDate(date: string | number | Date | null | undefined): string {
  if (!date) {
    return "";
  }
  try {
    const d = typeof date === "number" || typeof date === "string" ? new Date(date) : date;
    if (Number.isNaN(d.getTime())) {
      return "";
    }
    return d.toLocaleDateString("ru-RU");
  } catch {
    return "";
  }
}

export function formatDateTime(date: string | number | Date | null | undefined): string {
  if (!date) {
    return "";
  }
  try {
    const d = typeof date === "number" || typeof date === "string" ? new Date(date) : date;
    if (Number.isNaN(d.getTime())) {
      return "";
    }
    return d.toLocaleString("ru-RU");
  } catch {
    return "";
  }
}

export function getGreeting(): string {
  const h = new Date().getHours();
  if (h < 6) {
    return "Доброй ночи";
  }
  if (h < 12) {
    return "Доброе утро";
  }
  if (h < 18) {
    return "Добрый день";
  }
  return "Добрый вечер";
}
